import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Logo from '../assets/image/Logo.png';
import authService from '../services/loginService';
import '../../src/styles/userSideBar.css';

const UserSideBar = ({ isOpen = false, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        const confirmLogout = window.confirm('¿Está seguro que desea cerrar sesión?');
        if (confirmLogout) {
            authService.logout();
            navigate('/');
        }
    };

    const handleLinkClick = () => {
        // Cerrar sidebar en mobile cuando se hace clic en un enlace
        if (onClose) {
            onClose();
        }
    };

    const currentUser = authService.getCurrentUser();

    // Función para determinar si un link está activo
    const isActiveLink = (path) => {
        return location.pathname === path;
    };

    return (
        <div className={`user-sidebar-container ${isOpen ? 'active' : ''}`}>
            <div className="user-sidebar-logo">
                <img
                    className="user-sidebar-logo-image"
                    src={Logo}
                    alt="Logo"
                />
            </div>

            {currentUser && (
                <div className="user-sidebar-info">
                    <p className="user-sidebar-name">
                        {currentUser.name} {currentUser.lastname}
                    </p>
                </div>
            )}

            <ul className="user-sidebar-nav-list">
                <li className="user-sidebar-nav-item">
                    <Link 
                        to="/user-dashboard/inicio" 
                        className={`user-sidebar-nav-link ${isActiveLink('/user-dashboard/inicio') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                    >
                        <svg 
                            width="20" 
                            height="20" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                        >
                            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                            <polyline points="9,22 9,12 15,12 15,22"/>
                        </svg>
                        <span>Inicio</span>
                    </Link>
                </li>
                <li className="user-sidebar-nav-item">
                    <Link 
                        to="/user-dashboard/reservas" 
                        className={`user-sidebar-nav-link ${isActiveLink('/user-dashboard/reservas') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                    >
                        <svg 
                            width="20" 
                            height="20" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                        >
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                            <line x1="16" y1="2" x2="16" y2="6"/>
                            <line x1="8" y1="2" x2="8" y2="6"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        <span>Reservas</span>
                    </Link>
                </li>
                <li className="user-sidebar-nav-item">
                    <Link 
                        to="/user-dashboard/tiquetes" 
                        className={`user-sidebar-nav-link ${isActiveLink('/user-dashboard/tiquetes') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                    >
                        <svg 
                            width="20" 
                            height="20" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                        >
                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                            <polyline points="14,2 14,8 20,8"/>
                            <line x1="16" y1="13" x2="8" y2="13"/>
                            <line x1="16" y1="17" x2="8" y2="17"/>
                            <polyline points="10,9 9,9 8,9"/>
                        </svg>
                        <span>Tiquetes e Historial</span>
                    </Link>
                </li>
                <li className="user-sidebar-nav-item">
                    <Link 
                        to="/user-dashboard/personal" 
                        className={`user-sidebar-nav-link ${isActiveLink('/user-dashboard/personal') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                    >
                        <svg 
                            width="20" 
                            height="20" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                        >
                            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                            <circle cx="12" cy="7" r="4"/>
                        </svg>
                        <span>Perfil</span>
                    </Link>
                </li>
                <li className="user-sidebar-nav-item">
                    <Link 
                        to="/user-dashboard/payment" 
                        className={`user-sidebar-nav-link ${isActiveLink('/user-dashboard/payment') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                    >
                        <svg 
                            width="20" 
                            height="20" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                        >
                            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                            <line x1="1" y1="10" x2="23" y2="10"/>
                        </svg>
                        <span>Pago</span>
                    </Link>
                </li>
            </ul>

            <div className="user-sidebar-logout-section">
                <button 
                    className="user-sidebar-logout-button"
                    onClick={handleLogout}
                >
                    <svg 
                        className="user-sidebar-logout-icon" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                    >
                        <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
                        <polyline points="16,17 21,12 16,7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    Cerrar Sesión
                </button>
            </div>
        </div>
    );
};

export default UserSideBar;